import { render, staticRenderFns } from "./CookiesNotificationBanner.vue?vue&type=template&id=2af0b478&scoped=true&"
import script from "./CookiesNotificationBanner.vue?vue&type=script&lang=js&"
export * from "./CookiesNotificationBanner.vue?vue&type=script&lang=js&"
import style0 from "./CookiesNotificationBanner.vue?vue&type=style&index=0&id=2af0b478&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af0b478",
  null
  
)

export default component.exports